import React, { useState } from "react";
import api from "../api";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: async (payload) => {
      const res = await api.post("/auth/login", payload);
      return res.data;
    },
    onSuccess: (data) => {
      localStorage.setItem("token", data.token?.token);
      localStorage.setItem("userid", JSON.stringify(data.token?.userId));
      navigate("/");
    },
    onError: (error) => {
      console.error("Login failed:", error);
      setError(error.response?.data?.message || "Invalid credentials. Please try again.");
    },
  });

  const validateForm = () => {
    if (!username || !password) {
      setError("Please enter both email and password.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      setError("Please enter a valid email address.");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    loginMutation.mutate({ username, password });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f6f8f3"
      }}
    >
      <div
        style={{
          width: 400,
          backgroundColor: "#ffffff",
          borderRadius: 10,
          padding: 34,
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: 29,
            color: "#9DC33B",
            fontWeight: 700
          }}
        >
          Welcome to YESCAST
        </h2>

        {error && (
          <div style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "10px",
            borderRadius: "6px",
            marginBottom: "16px",
            fontSize: "14px",
            textAlign: "center",
            border: "1px solid #fca5a5"
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Username */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 6, fontSize: 14 }}>
              Email Address
            </label>
            <input
              type="text"
              placeholder="Enter Email Address"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (error) setError("");
              }}
              style={{
                width: "100%",
                padding: 10,
                borderRadius: 6,
                border: "1px solid #ccc",
                fontSize: 14,
                boxSizing: "border-box"
              }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 6, fontSize: 14 }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError("");
                }}
                style={{
                  width: "100%",
                  padding: "10px 40px 10px 10px",
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  fontSize: 14,
                  boxSizing: "border-box"
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#666",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loginMutation.isPending}
            style={{
              width: "100%",
              padding: 12,
              marginTop: 12,
              backgroundColor: loginMutation.isPending ? "#ccc" : "#9DC33B",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              fontSize: 15,
              fontWeight: 600,
              cursor: loginMutation.isPending ? "not-allowed" : "pointer",
              transition: "background-color 0.2s"
            }}
          >
            {loginMutation.isPending ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
